var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:{
    'v-data-table__mobile-table-row': this.isMobile,
    'bt-table-content-row': !this.isMobile,
    highlighted: _vm.isHighlighted,
  },on:{"click":function($event){return _vm.$emit('click')}}},_vm._l((_vm.headers),function(header,index){return _c(_vm.cellComponentType,{key:index,tag:"component",attrs:{"header":header,"item":_vm.item}},[_vm._t(("item." + (header.value)))],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }